module.exports = __webpack_public_path__ + "img/fclement.15c497dd.png";